<template>
  <div>
    <div><slot name="top"></slot></div>

    <div class="absence-table" style="overflow-x: scroll">
      <div class="d-flex table-header" :style="`width: 100%;${isDispoView ? 'min-width:1680px' : ''}; height: 50px`">
        <div
          class="overflow-hidden pa-1 table-header-cell"
          v-for="column in columns"
          :key="column.columnName"
          :style="`text-align:${column.align};${headerWidth(column)}`"
          @click="onHeaderClick(column)"
        >
          <div style="flex: 1" v-html="column.text"></div>
          <div style="width: 16px">
            <v-icon
              v-if="sortedColumnName === column.columnName && !!sortedDirection"
              small
              color="primary"
              :class="sortedDirection === 'asc' ? 'mdi-rotate-0' : 'mdi-rotate-180'"
            >
              mdi-arrow-up-bold
            </v-icon>

            <v-icon v-else-if="column.sortable" small color="grey"> mdi-arrow-up </v-icon>
          </div>
        </div>
      </div>
      <div :style="`width:100%;${isDispoView ? 'min-width:1680px' : ''}`">
        <v-virtual-scroll
          :items="items"
          :bench="bench"
          :height="`calc(100vh - ${!!$slots['footer'] ? '230px' : '205px'} - ${remainingHeight}px)`"
          :item-height="itemHeight"
          class="virtual-scroller-container"
        >
          <template v-slot:default="{ item }">
            <absences-row
              :class="rowClz(item)"
              :height="itemHeight"
              :columns="columns"
              :absence="item"
              :is-assigned-to-different-view="isAssignedToDifferentView(item)"
              @inlineChange="(args) => $emit('inlineChange', args)"
              @copyAction="(absence) => $emit('copyAction', absence)"
              @editAction="(absence) => $emit('editAction', absence)"
              @deleteAction="(absence) => $emit('deleteAction', absence)"
              @forwardAction="(absence) => $emit('forwardAction', absence)"
              @restoreAction="(absence) => $emit('restoreAction', absence)"
              @mailAction="(absence) => $emit('mailAction', absence)"
            ></absences-row>
          </template>
        </v-virtual-scroll>
      </div>
    </div>

    <div class="table-footer"><slot name="footer"></slot></div>
  </div>
</template>
<script>
import common from '@/mixins/common';
import AbsencesRow from '@/modules/customerVbzWorksheet/viewComponents/absences/absencesVirtualScroller/AbsencesRow.vue';
import wsMixin from '@/modules/customerVbzWorksheet/wsMixin';

export default {
  name: 'AbsencesVirtualScroller',
  components: { AbsencesRow },
  mixins: [common, wsMixin],
  props: {
    items: Array,
    columns: Array,
    isDispoView: Boolean,
    isZueri9View: Boolean,
    remainingHeight: Number,
    defaultSortedColumnDirection: String,
    defaultSortedColumn: String,
  },
  data() {
    return {
      bench: 15,
      sortedColumnName: 'reportedAtTime',
      sortedDirection: 'desc',
    };
  },
  computed: {
    itemHeight() {
      return this.isDispoView ? 40 : this.mdAndDown ? 85 : 40;
    },
  },
  methods: {
    isUpdated(absence) {
      if (this.isZueri9View) {
        // console.debug("isUpdated this.mx_zueri9States.open",this.mx_zueri9States.open, 'absence.zueri9State',absence.zueri9Status)
        return absence.zueri9State === this.mx_zueri9States.open;
      }
      // return absence.updated===true||absence._updated===true || absence._created===true;
      return absence.assignedTo === 'dispo' && absence.dispoStates === this.mx_dispoStates.open;
    },
    rowClz(absence) {
      let item = absence;
      return `${this.isUpdated(absence) ? 'updated-row' : ''}${item.deleted ? ` text--disabled` : ''}${
        this.isAssignedToDifferentView(item) ? ' is-forwarded' : ''
      }`;
    },
    headerWidth(column) {
      if (column.width) {
        return `width: ${column.width}px`;
      }
      return 'flex: 1';
    },
    onHeaderClick(column) {
      console.debug(`onHeaderClick sortable ${column.sortable} columnName=${column.columnName} dir=${this.sortedDirection}`);
      if (column.sortable) {
        if (this.sortedColumnName !== column.columnName) {
          this.sortedDirection = null;
        }
        this.sortedColumnName = column.columnName;

        if (!this.sortedDirection) {
          this.sortedDirection = 'asc';
        } else if (this.sortedDirection === 'asc') {
          this.sortedDirection = 'desc';
        } else {
          this.sortedDirection = this.defaultSortedColumnDirection;
          this.sortedColumnName = this.defaultSortedColumn;
        }
        this.$emit('onSortColumn', { columnName: this.sortedColumnName, dir: this.sortedDirection });
      }
    },

    isAssignedToDifferentView(item) {
      return (item.assignedTo === 'dispo' && this.isZueri9View) || (item.assignedTo === 'zueri9' && this.isDispoView);
    },
  },
};
</script>
<style scoped>
.absence-table {
  padding: 0 8px;
  display: flex;
  flex-direction: column;
}
.theme--light .absence-table {
  background: #fff;
  border: 4px solid white;
}
.theme--dark .absence-table {
  background: #1e1e1e;
  border: 4px solid #1e1e1e;
}
.theme--light .table-footer {
  background: #fefefe;
  border-top: 1px solid #e0e0e0;
}
.theme--dark .table-footer {
  background: #262626;
  border-top: 1px solid #303030;
  padding: 2px 0 0 0;
}

.theme--light .table-header {
  border-bottom: 1px solid #e0e0e0;
}
.theme--dark .table-header {
  border-bottom: 1px solid #404040;
}
.table-header-cell {
  font-size: 0.8rem;
  font-weight: 500;
  display: flex;
}
.theme--light .updated-row {
  background: #fcdab9;
}
.theme--dark .updated-row {
  background: #a44805;
}
.theme--light .edited-row {
  background: #87a81c;
}
.theme--dark .edited-row {
  background: #237020;
}
.virtual-scroller-container {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #90a4ae #eceff1;
}
</style>
